export type TWOFASTAGETYPE = 'email-otp' | 'authenticator-qr' | 'authenticator-otp' | 'authenticator-backup-code';

export const twoFaStageTitle: Record<TWOFASTAGETYPE, string> = {
	'email-otp': 'Email OTP',
	'authenticator-qr': 'Authenticator App',
	'authenticator-otp': 'Authenticator App',
	'authenticator-backup-code': 'Recovery Code',
};

export interface IAuthenticatorBackupCodeProps {
	onNext?: () => void;
	recoveryCodes: string[];
}

export type TwoFaActionType =
	| 'deactivate-authenticator'
	| 'activate-authenticator'
	| 'init-authenticator'
	| 'disable-email'
	| 'enable-email';

export type TwoFaCategory = 'email' | 'authenticator';
